import React, { useState, useEffect, useMemo } from 'react';
import {
  Box,
  Grid,
  Paper,
  Typography,
  Tooltip,
  TextField,
  Pagination,
  useMediaQuery,
  useTheme,
  Button,
  SelectChangeEvent,

} from '@mui/material';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import Image from '../../Assets/DefaultProfile.png';
import { useNavigate, useLocation } from 'react-router-dom';
import { useStyles } from './styles';
import routes from '../../Utils/routes';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  List,
  ListItem,
  ListItemButton,
  ListItemText,

} from '@mui/material';


const ITEMS_PER_PAGE = 20;

const NetworkMobileView: React.FC<any> = ({ cardData, type, showAll, title }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [totalPages, setTotalPages] = useState(1);
  const [selectedValues, setSelectedValues] = useState<any>({
    locations: [],
    graduationYear: '',
    currentCompany: '',
    postCompany: '',
    industry: '',
  });
  const [filteredResults, setFilteredResults] = useState<any[]>([]);
  const [sortDialogOpen, setSortDialogOpen] = useState(false);
  const [sortOption, setSortOption] = useState('');
  const [open, setOpen] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState<any>({
    locations: [],
    graduationYear: '',
    currentCompany: '',
    postCompany: '',
    industry: '',
  });
  const [sortFilterData, setSortFilterData] = useState<any[]>([]);
  const sourceData = state?.data?.length ? state?.data : cardData || [];
  const filteredData = useMemo(() => {
    let dataSource = state?.data || cardData || [];

    console.log(dataSource, searchQuery.trim(), "dataSource");

    // Apply search filter
    if (searchQuery.trim()) {
      dataSource = dataSource.filter((item: any) => {
        const nameMatch = item.Name?.toLowerCase().includes(searchQuery.toLowerCase());
        const designationMatch = item.Designation__c?.toLowerCase().includes(searchQuery.toLowerCase());
        return nameMatch || designationMatch;
      });
    }

    // Apply other filters
    if (appliedFilters.locations.length > 0) {
      dataSource = dataSource.filter((item: any) =>
        appliedFilters.locations.includes(item?.Addresses__r?.records?.[0]?.City__c)
      );
    }

    if (appliedFilters.graduationYear) {
      dataSource = dataSource.filter((item: any) =>
        item?.Ken_Alumni_CRM__r?.records?.[0]?.Year_of_Graduation__c === appliedFilters.graduationYear
      );
    }

    if (appliedFilters.currentCompany) {
      dataSource = dataSource.filter((item: any) =>
        item?.Ken_Alumni_CRM__r?.records?.[0]?.Current_Company__c === appliedFilters.currentCompany
      );
    }

    if (appliedFilters.postCompany) {
      dataSource = dataSource.filter((item: any) =>
        item?.Ken_Alumni_CRM__r?.records?.[0]?.Post_Company__c === appliedFilters.postCompany
      );
    }

    if (appliedFilters.industry) {
      dataSource = dataSource.filter((item: any) =>
        item?.Ken_Alumni_CRM__r?.records?.[0]?.Industry__c === appliedFilters.industry
      );
    }

    console.log("filteredData", sortOption, dataSource);
    if (sortOption) {
      switch (sortOption) {
        case 'A-Z':
          dataSource.sort((a: any, b: any) => a?.Name?.localeCompare(b?.Name));
          break;
        case 'Z-A':
          dataSource.sort((a: any, b: any) => b?.Name?.localeCompare(a?.Name));
          break;
        case 'Recently Joined':
          dataSource.sort((a: any, b: any) => new Date(b?.CreatedDate).getTime() - new Date(a?.CreatedDate).getTime());
          break;
        case 'Clear':
          dataSource = dataSource;
          break;
        default:
          break;
      }
    }

    return dataSource;
  }, [searchQuery, appliedFilters, state?.data, cardData, sortOption]);


  useEffect(() => {
    if (!showAll && !state?.data && cardData) {
      setTotalPages(1);
    } else {
      setTotalPages(Math.ceil(filteredData?.length / ITEMS_PER_PAGE));
    }
  }, [currentPage, showAll, filteredData]);



  const handlePageChange = (_: React.ChangeEvent<unknown>, page: number) => {
    setCurrentPage(page);
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleApply = () => {
    // Set applied filters and reset to page 1
    setAppliedFilters(selectedValues);
    setCurrentPage(1); // Reset to first page
    setOpen(false); // Close the filter dialog
  };

  const handleFilterChange = (filterName: string, value: any) => {
    setSelectedValues((prevValues: any) => ({
      ...prevValues,
      [filterName]: value,
    }));
  };

  const locationOptions: string[] = useMemo(() => {
    return Array.from(
      new Set(state?.data?.map((user: any) => user?.Addresses__r?.records?.[0]?.City__c))
    ).filter(Boolean) as string[];
  }, [state?.data]);

  const graduationYearOptions: string[] = useMemo(() => {
    return Array.from(
      new Set(state?.data?.map((user: any) => user?.Ken_Alumni_CRM__r?.records?.[0]?.Year_of_Graduation__c))
    ).filter(Boolean) as string[];
  }, [state?.data]);

  const currentCompanyOptions: string[] = useMemo(() => {
    return Array.from(
      new Set(state?.data?.map((user: any) => user?.Ken_Alumni_CRM__r?.records?.[0]?.Current_Company__c))
    ).filter(Boolean) as string[];
  }, [state?.data]);

  const postCompanyOptions: string[] = useMemo(() => {
    return Array.from(
      new Set(state?.data?.map((user: any) => user?.Ken_Alumni_CRM__r?.records?.[0]?.Post_Company__c))
    ).filter(Boolean) as string[];
  }, [state?.data]);

  const industryOptions: string[] = useMemo(() => {
    return Array.from(
      new Set(state?.data?.map((user: any) => user?.Ken_Alumni_CRM__r?.records?.[0]?.Industry__c))
    ).filter(Boolean) as string[];
  }, [state?.data]);
  const handleSort = (option: string) => {
    let sortedData = [...filteredData];
    setSortOption(option);

    console.log("handleSort", sortedData, sortOption, option, filteredData);

    switch (option) {
      case 'A-Z':
        sortedData.sort((a: any, b: any) => a?.Name?.localeCompare(b?.Name));
        break;
      case 'Z-A':
        sortedData.sort((a, b) => b?.contactDetails?.name?.localeCompare(a?.contactDetails?.Name));
        break;
      case 'Recently Joined':
        sortedData.sort((a, b) => new Date(b?.contactDetails?.joinedDate).getTime() - new Date(a?.contactDetails?.joinedDate).getTime());
        break;
      case 'Clear':
        sortedData = [...sourceData];
        break;
      default:
        break;
    }

    setSortFilterData(sortedData);
    setFilteredResults(sortedData);
    setCurrentPage(1);
  };



  const paginatedData = useMemo(() => {
    const isStateDataAvailable = state?.data?.length > 0;

    // if no state.data, show only 2 cards from cardData (filtered)
    if (!isStateDataAvailable) {
      return filteredData.slice(0, 2);
    }

    // otherwise, paginate filteredData
    if (showAll) return filteredData;

    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    console.log("paginatedData34334", filteredData, currentPage, showAll, startIndex, endIndex);
    return filteredData.slice(startIndex, endIndex);

  }, [filteredData, currentPage, showAll, state?.data, filteredResults]);

  const handleSearchChange = (e: any) => {
    const query = e.target.value;
    setSearchQuery(query);
    const filteredPaginatedData = filteredData.filter((item: any) =>
      item.Name?.toLowerCase().includes(query.toLowerCase())
    );


    setFilteredResults(filteredPaginatedData);

  };
  console.log("paginatedData123", paginatedData, filteredData);
  const isNetworkRoute = location.pathname === '/network/view-all-network';
  return (
    <div className={classes.networkCardContainermobile}>


      <Box width="100%">
        <Paper className={classes.cardHolder}>

          {paginatedData?.length === 0 ? (
            <>
              {(isNetworkRoute) && (
                <Box display="flex" justifyContent="flex-end" mb={2} padding={2}>
                  <TextField
                    variant="outlined"
                    placeholder="Search by name or designation"
                    size="small"
                    onChange={handleSearchChange}
                    value={searchQuery}
                    InputProps={{
                      style: { borderRadius: '8px', backgroundColor: '#fff' },
                    }}
                    sx={{
                      width: isMobile ? '100%' : '300px',
                      mr: isMobile ? 0 : 2,
                    }}
                  />
                </Box>
              )}
              <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" py={8} height={'50vh'}>
                <Typography variant="body2" color="textSecondary">
                  You have not {type} yet
                </Typography>
                <Typography variant="h5" textAlign={"center"} color="textSecondary" gutterBottom>
                  Get started by connecting with people in your network
                </Typography>
              </Box>

              {isNetworkRoute && (

                <Grid
                  container
                  spacing={2}
                  sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    backgroundColor: '#fff',
                    padding: 2,
                    zIndex: 1000,
                  }}
                >

                  <Grid item xs={6}>
                    <Button
                      size="small"
                      variant="contained"
                      fullWidth
                      sx={{
                        backgroundColor: '#E8EBF3',
                        color: '#000',
                        '&:hover': {
                          backgroundColor: '#dce0ec',
                        },
                      }}
                      onClick={() => setSortDialogOpen(true)}
                      className={classes.filterBtn}
                    >
                      Sort by
                    </Button>
                  </Grid>
                  <Grid item xs={6}>

                    <Button variant="contained" fullWidth 
                    onClick={handleOpen}>
                      Filters
                    </Button>

                  </Grid>
                </Grid>
              )}
            </>
          ) : (
            <div>
              <div>
                <Typography style={{ textAlign: 'left', padding: '10px', fontSize: '16px', fontWeight: 500 }}>{state?.title}</Typography>


                {(isNetworkRoute) && (
                  <Box display="flex" justifyContent="flex-end" mb={2} padding={2}>
                    <TextField
                      variant="outlined"
                      placeholder="Search by name or designation4"
                      size="small"
                      onChange={handleSearchChange}
                      value={searchQuery}
                      InputProps={{
                        style: { borderRadius: '8px', backgroundColor: '#fff' },
                      }}
                      sx={{
                        width: isMobile ? '100%' : '300px',
                        mr: isMobile ? 0 : 2,
                      }}
                    />
                  </Box>
                )}


                <Grid container >
                  {paginatedData?.map((data: any, index: number) => (
                    <Grid item xs={6} sm={12} md={2.7} key={data.Id || index} style={{ padding: '10px' }}>
                      <div
                        className={classes.networkCard}
                        onClick={() => {
                          navigate(`${routes.network}/${data.Id}`, {
                            state: { data: cardData, breadCrumbs: data.Name },
                          });
                        }}
                      >
                        <Grid container>
                          <Grid item xl={6} md={6} sm={4}></Grid>
                          {data?.Alm_Preferences__r?.records?.[0]?.Willing_to_help__c ? (
                            <Grid
                              item
                              xl={6}
                              md={6}
                              sm={8}
                              style={{
                                backgroundColor: '#2C60AA',
                                textAlign: "center",
                                padding: 7,
                                borderTopRightRadius: 12,
                                borderBottomLeftRadius: 12
                              }}
                            >
                              <Typography fontSize={12} color={"white"}>
                                Willing to help
                              </Typography>
                            </Grid>
                          ) : (
                            <Grid
                              item
                              xl={6}
                              md={6}
                              sm={8}
                              style={{
                                textAlign: "center",
                                padding: 7,
                                borderTopRightRadius: 12,
                                borderBottomLeftRadius: 12
                              }}
                            >
                              {/* Empty if not willing to help */}
                            </Grid>
                          )}
                        </Grid>
                        <Grid
                          spacing={1}
                          alignContent="center"
                          alignItems="center"
                          display="flex"
                          flexDirection="column"
                        >
                          {/* Profile Picture with Online Dot */}
                          <Box position="relative" width={100} height={100} mb={1}>
                            <img
                              src={
                                data.Profile_Picture_URL__c
                                  ? data.Profile_Picture_URL__c
                                  : Image
                              }
                              alt="featured img"
                              className={classes.cardImage}
                              style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }}
                            />

                            {/* Online Indicator Dot */}
                            {data?.Ken_Alumni_CRM__r?.records?.[0]?.Is_Logged_In__c && (
                              <Box
                                position="absolute"
                                top={100}
                                right={0}
                                width={14}
                                height={14}
                                borderRadius="50%"
                                bgcolor="#4CAF50"
                                border="2px solid white"
                              />
                            )}
                          </Box>
                          <Grid style={{ marginTop: '30px', textAlign: 'center' }}>
                            <Tooltip title={data.Name || ''}>
                              <Typography className={classes.cardHeader}>
                                {data.Name?.length > 15 ? `${data.Name.slice(0, 15)}...` : data.Name}
                              </Typography>
                            </Tooltip>
                            <Typography className={classes.cardActionContainerTypo}>
                              {data.Ken_Alumni_CRM__r?.records?.[0]?.Designation__c || '-'}
                            </Typography>
                            <Typography
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                margin: '20px 20px',
                                fontSize: '14px',
                                color: '#585A64',
                              }}
                            >
                              {(data?.Addresses__r?.records?.[0]?.City__c || data?.Addresses__r?.records?.[0]?.Country__c) ? (
                                <>
                                  <LocationOnOutlinedIcon style={{ fontSize: 18, marginRight: 4 }} />
                                  {data?.Addresses__r?.records?.[0]?.City__c || ''}
                                  {data?.Addresses__r?.records?.[0]?.Country__c ? `, ${data.Addresses__r?.records?.[0]?.Country__c}` : ''}
                                </>
                              ) : (
                                <Grid p={1}></Grid>
                              )}
                            </Typography>
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>
                  ))}

                  {isNetworkRoute && (

                    <Grid
                      container
                      spacing={2}
                      sx={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        backgroundColor: '#fff',
                        padding: 2,
                        zIndex: 1000,
                      }}
                    >

                      <Grid item xs={6}>
                        <Button
                          size="small"
                          variant="contained"
                          fullWidth
                          sx={{
                            backgroundColor: '#E8EBF3',
                            color: '#000',
                            '&:hover': {
                              backgroundColor: '#dce0ec',
                            },
                          }}
                          onClick={() => setSortDialogOpen(true)}
                          className={classes.filterBtn}
                        >
                          Sort by
                        </Button>
                      </Grid>
                      <Grid item xs={6}>

                        <Button variant="contained" fullWidth onClick={handleOpen}>
                          Filters
                        </Button>

                      </Grid>
                    </Grid>
                  )}
                  <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
                    <DialogTitle sx={{ fontSize: '18px', fontWeight: '500' }}>Filters</DialogTitle>
                    <DialogContent dividers>
                      <Grid container sx={{padding:1}}>
                        {/* Location */}
                        <InputLabel id="location-label" style={{ fontSize: 14, marginTop: 6 }}>Location</InputLabel>
                        <FormControl fullWidth size="small" margin="normal">
                          <Select
                            labelId="location-label"
                            multiple
                            value={selectedValues.locations}
                            onChange={(e) => handleFilterChange('locations', e.target.value)}
                            renderValue={(selected) => selected.join(', ')}
                          >
                            {locationOptions.map((city) => (
                              <MenuItem key={city as string} value={city as string}>
                                {city}
                              </MenuItem>
                            ))}

                          </Select>
                        </FormControl>

                        {/* Year of Graduation */}
                        <InputLabel id="year-label" style={{ fontSize: 14, marginTop: 6 }}>Year of Graduation</InputLabel>
                        <FormControl fullWidth size="small" margin="normal">
                          <Select
                            labelId="year-label"
                            value={selectedValues.graduationYear}
                            onChange={(e) => handleFilterChange('graduationYear', e.target.value)}
                          >
                            {graduationYearOptions.map((year) => (
                              <MenuItem key={year} value={year}>{year}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                        {/* Current Company */}
                        <InputLabel id="company-label" style={{ fontSize: 14, marginTop: 6 }}>Current Company</InputLabel>
                        <FormControl fullWidth size="small" margin="normal">
                          <Select
                            labelId="company-label"
                            value={selectedValues.currentCompany}
                            onChange={(e) => handleFilterChange('currentCompany', e.target.value)}
                          >
                            {currentCompanyOptions.map((company) => (
                              <MenuItem key={company} value={company}>{company}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                        {/* Post Company */}
                        <InputLabel id="post-company-label" style={{ fontSize: 14, marginTop: 6 }}>Post Company</InputLabel>
                        <FormControl fullWidth size="small" margin="normal">
                          <Select
                            labelId="post-company-label"
                            value={selectedValues.postCompany}
                            onChange={(e) => handleFilterChange('postCompany', e.target.value)}
                          >
                            {postCompanyOptions.map((postCompany) => (
                              <MenuItem key={postCompany} value={postCompany}>{postCompany}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                        {/* Industry */}
                        <InputLabel id="industry-label" style={{ fontSize: 14, marginTop: 6 }}>Industry</InputLabel>
                        <FormControl fullWidth size="small" margin="normal">
                          <Select
                            labelId="industry-label"
                            value={selectedValues.industry}
                            onChange={(e) => handleFilterChange('industry', e.target.value)}
                          >
                            {industryOptions.map((industry) => (
                              <MenuItem key={industry} value={industry}>{industry}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </DialogContent>
                    <DialogActions sx={{ px: 3, pb: 2 }}>
                      <Grid container spacing={2} >
                        <Grid item xs={6}>
                          <Button
                            size="small"
                            variant="contained"
                            fullWidth
                            onClick={handleClose}
                            sx={{
                              backgroundColor: '#E8EBF3',
                              maxWidth: '110px',
                              color: '#000',
                              '&:hover': {
                                backgroundColor: '#dce0ec',
                              },
                            }}
                            className={classes?.CancelBtn}
                          >
                            Cancel
                          </Button>
                        </Grid>
                        <Grid item xs={6}>
                          <Button
                            variant="contained"
                            fullWidth
                            onClick={handleApply}
                          >
                            Apply
                          </Button>
                        </Grid>
                      </Grid>
                    </DialogActions>

                  </Dialog>
                  <Dialog open={sortDialogOpen} onClose={() => setSortDialogOpen(false)}>
                    <DialogTitle sx={{ fontSize: '18px', fontWeight: '500' }} >Sort Options</DialogTitle>
                    <DialogContent>
                      <List>
                        {['Clear', 'A-Z', 'Z-A', 'Recently Joined'].map((option) => (
                          <ListItem disablePadding key={option}>
                            <ListItemButton
                              onClick={() => {
                                setSortOption(option);
                                handleSort(option); // Apply your sort logic
                                setSortDialogOpen(false); // Close dialog
                              }}
                            >
                              <ListItemText primary={option} />
                            </ListItemButton>
                          </ListItem>
                        ))}
                      </List>
                    </DialogContent>
                  </Dialog>

                </Grid>
              </div>
              {(isNetworkRoute) && (
                <Box display="flex" justifyContent="center" mt={3}>
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    variant="outlined"
                    shape="rounded"
                    siblingCount={1}
                    boundaryCount={1}
                    sx={{
                      marginBottom: '50px',
                      '& .MuiPaginationItem-root': {
                        borderRadius: '8px',
                        fontWeight: 400,
                        color: '#000',
                        border: '1px solid #E0E0E0',
                        '&:hover': {
                          backgroundColor: '#F5F5F5',
                        },
                      },
                      '& .MuiPaginationItem-page.Mui-selected': {
                        backgroundColor: '#123A6F',
                        color: '#fff',
                        fontWeight: 500,
                        '&:hover': {
                          backgroundColor: '#123A6F',
                        },
                      },
                      '& .MuiPaginationItem-ellipsis': {
                        color: '#000',
                      },
                      '& .MuiPaginationItem-previousNext': {
                        fontWeight: 400,
                        color: '#000',
                      },
                      '& .MuiPaginationItem-previousNext.Mui-disabled': {
                        color: '#C0C0C0',
                      },
                    }}
                  />
                </Box>
              )}
            </div>

          )}


        </Paper>
      </Box>
    </div>
  );
};

export default NetworkMobileView;
